import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router';
import {
  Box,
  Container,
  CssBaseline,
  Stack,
  Grid,
  Typography,
  Button,
  IconButton
} from '@mui/material';
import { Link } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';
import { MdOutlineClose } from 'react-icons/md';
import WebcamCaptureSelfie from '../CameraComponents/WebcamCaptureSelfie';

import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
// import DialogMsg from '../../global/DialogMsg';
import { userDataFromLocal } from '../utils/getUserDetails';
import DialogMsg from '../../global/DialogMsg';
import { getScreenShots } from '../utils/MakePdf';
import { useTranslation } from 'react-i18next';

const { FaceMatch, GetFileFromUrl, UploadImage } = onBoardingEkycServices;

const Selfie = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const perviewImageRef = useRef(); // preview image ref when completed selfie smile,blink
  const [visibleSelfie, setVisibleSelfie] = useState(true);
  const [webCamShowHide, setWebCamShowHide] = useState(true);
  const [count, setCount] = useState(3);
  const [counter, setCounter] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [circularWebCam, setCircularWebCam] = useState('webcamstyle');
  const [selfSelfieImgSrc, setSelfSelfieImgSrc] = useState('');
  const [previewImageSrcm, setPreviewImageSrc] = useState('');
  const [waterMarkValue, setWaterMarkValue] = useState(null);
  const [heading, setHeading] = useState(t('Selfie instruction'));
  const [docFileData, setDocFileData] = useState(null);

  const [isSuccess, setIsSuccess] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');

  console.log('previewImageSrcm', previewImageSrcm);

  // Take selfie handler
  const selfiPhotoHandler = () => {
    GetFileFromUrlApi(); // GetfileFromURLApi to get docSelfie pic
    // setMode('secondTime');
    setTimeout(() => {
      setVisibleSelfie(false);
      setWebCamShowHide(false);
    }, 200);
  };
  const iconButtonHandler = (e) => {
    setVisibleSelfie(true);
    setWebCamShowHide(true);
  };

  useEffect(() => {
    if (count === 0) {
      // setClickPic(true);
      setCount(3);
      setCounter(false);
      // setOpenLoader(true);
    }
    let timer = count > 0 && counter && setInterval(() => setCount(count - 1), 1000);
    return () => clearInterval(timer);
  }, [count, counter]);

  useEffect(() => {
    if (previewImageSrcm !== '') {
      setHeading(t('Selfie preview'));
    }
  }, [previewImageSrcm]);

  // Image Preview code here
  // Dialog Retake photo
  const handleRetackPhoto = () => {
    setWebCamShowHide(false);
  };

  const handlContinue = () => {
    if (isSuccess) {
      UploadImageApiCallBack();
    }
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  // api section is going to start
  const fireFaceMatchApi = async (selfie) => {
    try {
      const userData = userDataFromLocal();
      const applicationNo = userData?.applicationNo;

      const facematchForm = new FormData();
      facematchForm.append('selfieFile', selfie);
      facematchForm.append('applicationNo', applicationNo);
      console.log('GetFileFromUrlApi', docFileData);
      if (docFileData === null) {
        const getDocfile = await GetFileFromUrlApi();

        facematchForm.append('docFile', getDocfile);
      } else {
        facematchForm.append('docFile', docFileData);
      }

      const FaceMatchResponse = await FaceMatch(facematchForm);
      if (FaceMatchResponse.status === 'Success') {
        // fireUploadImageApi(selfie);
        setIsSuccess(true);

        // for the time being if data face_match_result.isIdentical not true then proceed ahead will delete or sift code into below where is true
        let existingJourney = localStorage.getItem('journey');
        // If 'journey' already exists, parse it from JSON
        existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
        const newData = {
          ...existingJourney,
          selfie: FaceMatchResponse.data
        };
        localStorage.setItem('journey', JSON.stringify(newData));
        // for the time being if data face_match_result.isIdentical not true, code will shift into true condition, delete when data.face_match_result.isIdentical === true

        if (FaceMatchResponse.data.face_match_result.isIdentical === true) {
          // const SrpFaceMatch = CryptoJS.AES.encrypt(
          //   JSON.stringify(FaceMatchResponse.data),
          //   'faceMatch'
          // ).toString();

          // localStorage.setItem(
          //   'e13ehdnf06b-72p6-4581-86a3-c0a465e63d75-faceMatch',
          //   JSON.stringify(SrpFaceMatch)
          // );

          // if (selfiCounter === selfiWithRetake) {
          //   if (
          //     getStartUpConfigResponse?.mandatory?.filter(
          //       (item) => item.profileName === 'PREVIEW IMAGE WITH WATERMARK'
          //     )[0].isEnabled === false
          //   ) {
          //     handleClickErrorOpen();
          //   } else {
          //   }
          // } else {
          //   setVisibleSelfiePreview(true);
          // }

          setWebCamShowHide(true);
          setVisibleSelfie(false);
        } else {
          // handleClickErrorOpen(true);
        }
      } else if (FaceMatchResponse.status === 'error') {
        setDialogMsg(FaceMatchResponse.error);
        setOpenDialogeMsg(true);
        // fireUploadImageApi(selfie);
        // handleClickErrorOpen(true);
      } else if (FaceMatchResponse.error === 'Bad Request') {
        setDialogMsg('Please retake once again');
        setOpenDialogeMsg(true);
        // fireUploadImageApi(selfie);
        // handleClickErrorOpen(true);
      } else {
        setDialogMsg(t('Something went wrong'));
        setOpenDialogeMsg(true);
        // fireUploadImageApi(selfie);
        // setOpenLoader(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // GetFileFromUrlApi
  const GetFileFromUrlApi = async () => {
    try {
      // const localStorageData = localStorage.getItem('journey');
      // const localStorageParsedData = localStorageData ? JSON.parse(existingJourney) : {};
      let localStorageData = localStorage.getItem('journey');
      localStorageData = localStorageData ? JSON.parse(localStorageData) : {};

      // const credential = {
      //   fileUrl: localStorageData?.OCR?.doc_aadhar?.doc_url_front_aadhar?.doc_url
      // };
      const credential = {
        fileUrl: localStorageData?.OCR?.doc_aadhar?.doc_url
      };
      const GetFileFromUrlResponse = await GetFileFromUrl(credential);
      console.log('GetFileFromUrlResponse', GetFileFromUrlResponse);
      setDocFileData(GetFileFromUrlResponse);
      return GetFileFromUrlResponse;
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // function used to delay due to getscreenshot taking time as promise
  const UploadImageApiCallBack = async () => {
    // console.log('getCanvasgetCanvas', canvasId, type);

    const getCanvas = await getScreenShots('#sendWatermarkImage');
    getCanvas.toBlob(function (blob) {
      UploadImageApi(blob);
      // console.log('getCanvasgetCanvas', blob);
      const fileReader = new FileReader();
      // console.log('getCanvasgetCanvas', fileReader);
      fileReader.onload = function (event) {
        const base64String = event.target.result;
        // console.log('getCanvasgetCanvas', base64String);
        // UploadImageApi(base64String);
      };
      fileReader.readAsDataURL(blob);
    });
  };

  const UploadImageApi = async (watermarkFile) => {
    const newFile = new File([watermarkFile], `selfi.jpg`, {
      type: 'image/jpg',
      lastModified: new Date().getTime()
    });

    try {
      // console.log('base64data', watermarkFile);
      const userData = userDataFromLocal();
      const applicationNo = userData?.applicationNo;
      console.log('applicationNo', applicationNo);
      setOpenloader(true);
      const id = userData?.id;

      const formOcr = new FormData();
      formOcr.append('docId', id);
      formOcr.append('channelName', 'W');
      formOcr.append('docType', 'SelfiWaterMark'); // SelfiWDWaterMark, NONOCR
      formOcr.append('organizationId', 1);
      formOcr.append('applicationNo', applicationNo);
      formOcr.append('file', newFile ? newFile : null);
      formOcr.append('isWatermarked', true);
      formOcr.append('isBackendImage', false);

      const headerCredential = {
        languageId: 1,
        countryId: 1
      };

      const UploadImageResponse = await UploadImage(headerCredential, formOcr);
      if (
        UploadImageResponse.status === 'Success' &&
        Object.keys(UploadImageResponse.data).length > 0
      ) {
        // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
        let existingJourney = localStorage.getItem('journey');
        // If 'journey' already exists, parse it from JSON
        existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
        const newData = {
          ...existingJourney,
          selfie: {
            ...existingJourney.selfie,
            selfieDocurl: UploadImageResponse.data
          }
        };
        localStorage.setItem('journey', JSON.stringify(newData));
        navigate('/in/personal-info'); // all success then redirect to other page
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(UploadImageResponse.message);
        // setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };
  // useEffect(() => {
  //   GetFileFromUrlApi();
  // }, []);

  return (
    <>
      <Loader openloader={openloader} />
      {/* <PageHeading pageTitle="Selfie instruction" /> */}
      <PageHeading pageTitle={heading} />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        {visibleSelfie && (
          <Box textAlign="center" mb={3}>
            <Box mb={3} className="imagePreviewBox">
              <img
                src="/static/selfieW.svg"
                alt="Document Preview"
                className="imagePreviewFrame2"
              />
            </Box>
            <Box>
              <Typography variant="h6" className="cameraTitle" mb={2}>
                {t('Capture selfie')}
              </Typography>
              <Typography variant="body2" mb={3}>
                {t('Hold still and maintain a neutral expression when capturing the selfie')}
              </Typography>
              {/* <Link className="mainBtn" to="/camera-selfie">
                Take a selfie
              </Link> */}
              <Box>
                <Button
                  className="mainBtn"
                  // disabled={disableButton}
                  onClick={(e) => {
                    selfiPhotoHandler();
                  }}
                >
                  {t('Take a selfie')}
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        {!webCamShowHide ? (
          <Box mb={3} className="selfieContainerStyle">
            <IconButton
              size="small"
              className="closeMarkStyle"
              onClick={(e) => {
                iconButtonHandler(e);
              }}
            >
              <MdOutlineClose size={24} />
            </IconButton>
            {counter && (
              <div
                style={{
                  color: '#fff',
                  fontSize: 40,
                  fontWeight: 'bolder',
                  zIndex: 1,
                  position: 'absolute',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {count}
              </div>
            )}
            <Box className="cameraPreviewBox">
              <WebcamCaptureSelfie
                // width={640}
                // height={374}
                circularWebCam={circularWebCam}
                setSelfSelfieImgSrc={setSelfSelfieImgSrc}
                setPreviewImageSrc={setPreviewImageSrc}
                setVisibleSelfie={setVisibleSelfie}
                // GetFileFromUrlApi={GetFileFromUrlApi}
                // docFileData={docFileData}
                fireFaceMatchApi={fireFaceMatchApi}
                // handleClickErrorOpen={handleClickErrorOpen}
                setSelfieLoader={setOpenloader}
                // navigateTo="faceselfie"
                // setAlternatedAccess={setAlternatedAccess}
                setWebCamShowHide={setWebCamShowHide}
                // setVisibleSelfiePreview={setVisibleSelfiePreview}
                // // getFileFromUrlApiResponse={getFileFromUrlApiResponse}
                setCounter={setCounter}
                // counter={counter}
                // count={count}
                // clickPic={clickPic}
                // selfiCounter={selfiCounter}
                // selfiWithRetake={selfiWithRetake}

                // perviewImageRef={perviewImageRef}
              />
            </Box>
          </Box>
        ) : (
          ''
        )}

        {previewImageSrcm !== '' && (
          <>
            <Box ref={perviewImageRef} className="imagePreviewBox patent" textAlign="center">
              <img
                id="sendWatermarkImage"
                src={previewImageSrcm}
                alt=""
                className="imagePreviewFrame"
              />
            </Box>
            {/* <Box
              className="waterMarkContent"
              style={{
                fontSize: window.screen.width < 500 ? '8vw' : '2vw',
                transform: 'rotateZ(-26deg)'
              }}
            >
              Kalolytic solutions pvt ltd.
              <br />
              {waterMarkValue ? waterMarkValue : ''}
            </Box> */}

            <Box textAlign="center" mt={3}>
              <Button onClick={handlContinue} className="mainBtn btnLink">
                {t('Continue')}
              </Button>
              {/* <Link to="/in/personal-info" className="mainBtn btnLink">
                Continue
              </Link> */}
              <Link onClick={() => handleRetackPhoto()} className="mainBtn btnLink">
                {t('Retake')}
              </Link>
            </Box>
          </>
        )}

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default Selfie;
